import { Record } from 'immutable'

const SiteLinkRecord = Record({ // eslint-disable-line new-cap
  url: null,
  key: null,
  status: 0, // -1 => error, 0 => unprocessed, 1 => processed
  statusCode: null,
  elapsedTime: null,
  index: 0,
  depth: 0,
})

export default class SiteLink extends SiteLinkRecord {
  getStatusLabel() {
    switch (this.statusCode) {
      case 403:
        return 'error'
      case 200:
        return 'processed'
      default:
        return 'unprocessed'
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/links/site-link.js